import { useQuery } from "@tanstack/react-query";
import { getTraineePreferences } from "../../api/generations";

/**
 * Custom hook to get the preferences of a specific trainee.
 * @param memberID The ID of the trainee member.
 */
const useTraineePreferences = (memberId: number | null) => {
  // ----------------------------------------------------------------------------------
  // getTraineePreferences query
  const { data: traineePreferencesData } = useQuery({
    queryKey: ["traineePreferences", memberId],
    queryFn: () => {
      if (typeof memberId === "number") {
        return getTraineePreferences(memberId);
      }
      return Promise.resolve(null);
    },
  });

  const traineePreferences = traineePreferencesData?.data || null;
  return {
    traineePreferences,
    isTraineePreferencesFetched: !!traineePreferencesData,
  };
};

export default useTraineePreferences;
